import { MibeModel } from './mibemodel.model';

export class Vocals implements MibeModel {
  id: number;
  name: string;
  added_by_role: number;

  /**
   * Create a Vocals.
   * @param {any} json - The JSON object with which to construct our Vocal.
   */
  constructor(json:any) {
    this.loadWithJSON(json);
  }
  /**
   * Load a Vocal.
   * @param {any} json - The JSON object with which to load our Vocal.
   */
  loadWithJSON(json: any) {
    if (!json) {
      return;
    }
    this.id = json.id;
    this.name = json.name;
    this.added_by_role = json.added_by_role
  }
  /**
   * Returns a JSON representation of our Vocal
   * @return {any} - The JSON representation of our Vocal
   */
  toJSON() {
    var json: any = {
      'id': this.id,
      'name': this.name,
      'added_by_role': this.added_by_role
    };
    return json;
  }
}
